"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { SectionStrip } from "@/components/layout/SectionStrip";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { ResolvedListSection } from "@/utilities/data/getPlayersPageData";
interface Props {
  section: ResolvedListSection;
  allowPlayerPhotos: boolean;
}
export const PlayerListBlock: React.FC<Props> = t0 => {
  const $ = _c(19);
  const {
    section,
    allowPlayerPhotos
  } = t0;
  const nav = useNavigation();
  if (section.players.length === 0) {
    return null;
  }
  const t1 = section.brandedStyle;
  let t2;
  if ($[0] !== section.badgeUrl || $[1] !== section.subtitle || $[2] !== section.title) {
    t2 = (section.title || section.subtitle || section.badgeUrl) && <header className="flex items-center gap-3 mb-4">{section.badgeUrl && <div className="w-10 h-10 relative shrink-0"><Image src={section.badgeUrl} alt={section.title ?? ""} fill={true} sizes="40px" className="object-contain" unoptimized={true} /></div>}<div className="min-w-0">{section.title && <h2 className="text-xl md:text-2xl font-bold leading-tight truncate">{section.title}</h2>}{section.subtitle && <p className="text-sm opacity-80 truncate">{section.subtitle}</p>}</div></header>;
    $[0] = section.badgeUrl;
    $[1] = section.subtitle;
    $[2] = section.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== allowPlayerPhotos || $[5] !== nav || $[6] !== section.players) {
    let t4;
    if ($[8] !== allowPlayerPhotos || $[9] !== nav) {
      t4 = p => {
        const photo = allowPlayerPhotos ? p.photo : undefined;
        const href = p.playerId ? nav.player(p.playerId) : null;
        const card = <div className="flex flex-col items-center text-center bg-card text-card-foreground border border-border rounded-lg p-3 transition-colors hover:opacity-95"><div className="w-20 h-20 rounded-full overflow-hidden bg-muted mb-3">{photo ? <img src={photo} alt={p.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-muted-foreground">{p.name.charAt(0)}</div>}</div><p className="font-semibold text-sm leading-snug line-clamp-2">{p.name}</p>{p.teamName && <span className="mt-1.5 text-xs text-card-foreground/70 line-clamp-1">{p.teamName}</span>}</div>;
        return href ? <Link key={p.id} href={href} prefetch={false} className="block">{card}</Link> : <div key={p.id}>{card}</div>;
      };
      $[8] = allowPlayerPhotos;
      $[9] = nav;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = section.players.map(t4);
    $[4] = allowPlayerPhotos;
    $[5] = nav;
    $[6] = section.players;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <div className="py-6">{t2}{t4}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== section.brandedStyle || $[17] !== t5) {
    t6 = <SectionStrip brandedStyle={t1}>{t5}</SectionStrip>;
    $[16] = section.brandedStyle;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};